import styled, { css } from "styled-components"
import tw from "tailwind.macro"
import { Container } from "../elements/Content"
import { H3Style, PStyle, textStyleBase } from "../elements/Text"

const ImageWrap = css`
  width: 350px;
`

export default styled(Container)`
  > div {
    ${tw`py-12 text-black font-sans`};

    > * {
      max-width: 740px;
      margin: 0 auto;
    }

    h2,
    h3,
    h4 {
      ${H3Style}
      ${tw`my-4`};
      font-weight: bold;
    }
    h2 {
      font-size: 30px;
    }
    h3 {
      font-size: 24px;
    }

    p,
    ul,
    li {
      ${PStyle}
    }

    p,
    ul {
      ${tw`mt-6`};
      ${tw`mb-6`};
    }

    h2,
    h3,
    h4,
    p,
    li {
      ${tw`text-grey-darkest`};
      ${tw`text-left`};
    }

    img {
      max-width: 100%;
    }

    pre[class*="language-"] {
      margin-top: 0;
    }

    @media (min-width: 992px) {
      .float-right {
        ${ImageWrap}
        float: right;
        margin-right: -120px;
        margin-left: 30px;
      }
    }

    .highlight {
      display: block;
      ${tw`text-pink`};
      margin: 40px auto;
      max-width: 450px;
      font-size: 24px;
      font-style: italic;
      text-align: center;
    }

    @media (min-width: 992px) {
      .float-left {
        ${ImageWrap}
        float: left;
        margin-right: 30px;
        margin-left: -120px;
      }
    }

    .image-frame {
      display: block;
      text-align: center;
      margin-top: 30px;
      margin-bottom: 30px;

      .image-frame-caption {
        color: grey;
      }
    }

    .gif_player {
      display: inline-block;
      position: relative;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      -webkit-touch-callout: none;
      -webkit-tap-highlight-color: transparent;
      cursor: pointer;

      &.playing .play_button {
        transform: translate(-50%, -50%) scale(0) rotate(180deg);
        opacity: 0.5;
      }

      img {
        max-width: 100%;
      }

      &:hover .play_button {
        background-color: rgba(0, 0, 0, 0.7);
        box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.7);
      }

      .play_button {
        background-color: rgba(0, 0, 0, 0.5);
        /* border: 2px dashed #fff; */
        border-radius: 50%;
        box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.5);
        color: #fff;
        font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
        font-size: 48px;
        text-align: center;
        vertical-align: text-bottom;
        line-height: 85px;
        left: 50%;
        /* padding-left: 10px; */
        opacity: 1;
        padding: 1px 0 0px 8px;
        width: 85px;
        height: 85px;
        position: absolute;
        top: 50%;
        -webkit-transform: translate(-50%, -50%) scale(1) rotate(0deg);
        transform: translate(-50%, -50%) scale(1) rotate(0deg);
        -webkit-transition: opacity 0.4s, -webkit-transform 0.4s;
        transition: opacity 0.4s, -webkit-transform 0.4s;
        transition: transform 0.4s, opacity 0.4s;
        transition: transform 0.4s, opacity 0.4s, -webkit-transform 0.4s;

        &::after {
          content: "▶";
        }
      }
    }

    table {
      border-collapse: collapse;
      border: 1px solid black;
      margin-top: 40px;
      margin-bottom: 40px;

      p {
        margin-top: 0;
        margin-bottom: 0;
      }

      tr:hover {
        background-color: #efefef;
      }

      th,
      td {
        border-right: 1px solid black;
        border-left: 1px solid black;
        padding: 12px;
      }
    }

    hr {
      margin-top: 60px;
      margin-bottom: 40px;
    }

    blockquote {
      ${textStyleBase};
      ${tw`mb-8 mt-8 relative block`};
      text-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
      padding-left: 24px;
      border-left: 0.25rem solid var(--theme-ui-colors-standardLine, #f0f0f2);

      p {
        font-style: italic;
      }
    }

    .gatsby-code-title {
      background-color: #e6e5e3;
      font-family: Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace;
      font-size: 1em;
      text-align: right;
      padding: 10px;
    }

    .gatsby-highlight {
      margin-bottom: 2rem;
    }
  }
`
